import React, {createContext, useContext, useEffect, useState} from 'react';
import {notification} from 'antd';
import baseApi, {
  getAccessToken,
  setAuthToken,
  setUserRole,
} from '../../base-api';
import {
  constructMenu,
  parseJwt,
  prepareAuthentication,
  isShowRecaptcha,
} from '@ict/utility/Utils';
import {useGoogleReCaptcha} from 'react-google-recaptcha-v3';
import {FETCH_SUCCESS} from '../../../../shared/constants/ActionTypes';
import PropTypes from 'prop-types';
import {SUCCESS} from 'shared/constants/AppEnums';
import {encryptStorage} from '../../../utility/Storage';
import {menuDefault} from '../../../../pages';
import routeConfig from '../../../../pages/routeConfig';
import {useDispatch} from 'react-redux';
import {useHistory} from 'react-router-dom';
import { setMustChangePasswordStatus } from '../../../../redux/actions/UserMustChangePassword';

const JWTAuthContext = createContext();
const JWTAuthActionsContext = createContext();

export const useJWTAuth = () => useContext(JWTAuthContext);

export const useJWTAuthActions = () => useContext(JWTAuthActionsContext);

const JWTAuthAuthProvider = ({children}) => {
  const {executeRecaptcha} = useGoogleReCaptcha();
  const history = useHistory();
  const [AuthData, setJWTAuthData] = useState({
    user: {},
    isAuthenticated: false,
    isLoading: false,
  });

  useEffect(() => {
    if (
      encryptStorage.getItem('token') &&
      history.location.pathname.includes('laju/ui')
    ) {
      logout();
    }
  }, []);

  useEffect(() => {
    if (
      !history.location.pathname.includes('laju/ui') &&
      AuthData.isAuthenticated === false
    ) {
      logout();
    }
  }, [AuthData]);

  const dispatch = useDispatch();

  const getPublicKey = async () => {
    const {data} = await baseApi.get('public/publickey');
    encryptStorage.setItem('publicKey', `${data?.content?.publicKey}`);
    setJWTAuthData({
      ...AuthData,
      isAuthenticated: false,
      isLoading: false,
    });
    dispatch({type: FETCH_SUCCESS});
    return data?.content?.publicKey;
  };

  const signInUser = async ({username, password, vendorId}) => {
    const {data} = await baseApi.get('public/publickey');
    if (data.status === SUCCESS) {
      const pubKey = data?.content?.publicKey;
      encryptStorage.setItem('publicKey', `${pubKey}`);
      encryptStorage.setItem('vendorId', `${vendorId}`);
      setJWTAuthData({
        ...AuthData,
        isAuthenticated: false,
      });
      dispatch({type: FETCH_SUCCESS});
      if (pubKey) {
        const auth = prepareAuthentication(username, password, pubKey);
        // const bodyPayload = {
        //   username: username,
        //   password: password,
        // }; 
        setAuthToken(auth);
        if (auth) {
          if (!executeRecaptcha) {
            notification.info({
              description: 'ReCaptcha Is Not Ready',
              style: {
                backgroundColor: '#FFF1F0',
                border: '1px solid #FFA39E',
              },
            });
            return;
          }
          const tokenReCaptcha = await executeRecaptcha('token');
          encryptStorage.setItem('tokenReCaptcha', `${tokenReCaptcha}`);
          const {data} = await baseApi.post('login');
          const menu = data.content?.parentMenu;
          if(data.content?.isMustChangePassword){
            dispatch(setMustChangePasswordStatus({
              isMustChangePassword: data.content?.isMustChangePassword,
              pubKey: pubKey,
              oldPassword: password,
              username: username,
              vendorId: vendorId
            }))
          } else {
            if (data.status === SUCCESS) {
              isShowRecaptcha(false);
              const jwtParsed = parseJwt(getAccessToken());
              encryptStorage.setItem(
                'userBranch',
                jwtParsed.additionalInfo?.isBranch,
              );
              setUserRole(jwtParsed.additionalInfo?.role);
              const mergeMenu = menuDefault.concat(menu);
              routeConfig.splice(0, routeConfig.length);
              mergeMenu.map(function (element) {
                routeConfig.push(element);
              });
              constructMenu(jwtParsed.permissions);
              const {data} = await baseApi.get(
                `secured/vendoruser/user-information`,
              );
              setJWTAuthData({
                ...AuthData,
                user: data.content,
                isAuthenticated: true,
                isLoading: false,
              });
            } else {
              setJWTAuthData({
                ...AuthData,
                isAuthenticated: false,
                isLoading: false,
              });
            }
          }
        }
      }
    }
  };

  const logout = async () => {
    await baseApi.post('secured/logout');
    setAuthToken(null);
    encryptStorage.removeItem('userBranch');
    encryptStorage.removeItem('publicKey');
    encryptStorage.removeItem('vendorId');
    encryptStorage.removeItem('userRole');
    encryptStorage.removeItem('tokenReCaptcha');
    encryptStorage.removeItem('token');
    isShowRecaptcha(true);

    setJWTAuthData({
      ...AuthData,
      isLoading: false,
      isAuthenticated: false,
    });
    history.replace('/laju/ui');
  };

  const setJWTData = (isAuth) => {
    setJWTAuthData({
      ...AuthData,
      isLoading: false,
      isAuthenticated: isAuth,
    });
  };

  return (
    <JWTAuthContext.Provider value={{...AuthData}}>
      <JWTAuthActionsContext.Provider
        value={{
          setJWTData,
          signInUser,
          logout,
          getPublicKey,
        }}>
        {children}
      </JWTAuthActionsContext.Provider>
    </JWTAuthContext.Provider>
  );
};

export default JWTAuthAuthProvider;

JWTAuthAuthProvider.propTypes = {
  children: PropTypes.node.isRequired,
};
